import '@/config/bootstrap';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './pinia';

import stopChangeFontSize from '@/features/weixin/utils/stopChangeFontSize';
stopChangeFontSize();

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^wx-/];

import vant from '@/features/common/libs/unvant';
Vue.use(vant);

import authCheck from '@/features/auth/check';
import { Dialog } from 'vant';

authCheck()
  .then(() => {
    const app = new Vue({
      router,
      pinia,
      render: (h) => h(App),
    });
    router.onReady(() => app.$mount('#app'));
  })
  .catch((e) => {
    if (+e?.status === 402 && e.message) {
      location.replace('/?#/update?t=' + e.message);
      return;
    }
    if (!e) return;
    Dialog.alert({ message: e?.message || e }).then(() => {
      location.reload();
    });
    throw e;
  });
